import { Button, Form, FormInstance } from "antd";
import React from "react";

export const SubmitButton: React.FC<React.PropsWithChildren<{form: React.RefObject<FormInstance | null>}>> = ({ form, children }) => {
  const [submittable, setSubmittable] = React.useState<boolean>(false);

  // Watch all values
  const values = Form.useWatch([], form.current?.getFieldsValue());

  React.useEffect(() => {
    form
      .current!
      .validateFields({ validateOnly: true })
      .then(() => setSubmittable(true))
      .catch(() => setSubmittable(false));
  }, [form, values]);

  return (
    <Button type="primary" variant="filled" htmlType="submit" disabled={!submittable}>
      {children}
    </Button>
  );
};
